import styled from "styled-components";

export const GameJackpotDefaultBox = styled.div`
  width: 100%;
  color: ${props => props.theme.colors.moneyColor};
  font-weight: 600;
`